import React from "react";

export default function BankStatementView({ data }) {
  if (!data) return null;

  return (
    <>
      <br />

      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] text-white">
        <h2 className="text-lg font-semibold">Bank Statement Details</h2>
      </div>

      {/* Bank + Statement Info */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        <div>
          <h3 className="font-semibold mb-2">Bank Information</h3>
          <p><b>Bank Name:</b> {data.bank_name || "-"}</p>
          <p><b>Account Holder:</b> {data.account_holder || "-"}</p>
          <p><b>Account Number:</b> {data.account_number || "-"}</p>
          <p><b>Address:</b> {data.address || "-"}</p>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Statement Information</h3>
          <p>
            <b>Statement Period:</b>{" "}
            {data.period_start || "-"} - {data.period_end || "-"}
          </p>
          <p>
            <b>Opening Balance:</b>{" "}
            {data.currency} {data.opening_balance ?? "-"}
          </p>
          <p>
            <b>Closing Balance:</b>{" "}
            {data.currency} {data.closing_balance ?? "-"}
          </p>
          <p><b>Currency:</b> {data.currency || "-"}</p>
        </div>
      </div>

      {/* Irregularities */}
      <div
        className="mt-4 p-3 border rounded-lg text-black"
        style={{ background: "aliceblue" }}
      >
        <b>Irregularities:</b> {data.irregularities || "None"}
      </div>

      {/* Transactions */}
      <div className="border bg-white shadow mt-6">
        <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
          Transactions
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left border">Date</th>
                <th className="px-4 py-2 text-left border">Description</th>
                <th className="px-4 py-2 text-right border">Debit</th>
                <th className="px-4 py-2 text-right border">Credit</th>
                <th className="px-4 py-2 text-right border">Balance</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data.transactions) && data.transactions.length ? (
                data.transactions.map((txn) => (
                  <tr key={txn.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{txn.date}</td>
                    <td className="px-4 py-2 border">{txn.description}</td>
                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.debit_amount ? "text-red-600" : "text-gray-400"
                      }`}
                    >
                      {txn.debit_amount || ""}
                    </td>
                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.credit_amount ? "text-green-600" : "text-gray-400"
                      }`}
                    >
                      {txn.credit_amount || ""}
                    </td>
                    <td className="px-4 py-2 text-right border font-semibold">
                      {txn.balance}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-3">
                    No Transactions Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
